import React, { useEffect, useState } from "react";
import commonNetwork, { commonRootUrl, rootUrl } from "../../common/api/commonNetwork";





const FooterAllBrands = ({apiInfo}) => {

    const [brandList, setBrandList] = useState([]);

    useEffect(() => {

        selectAllBrand();
    }, []);

    const selectAllBrand = async () => {

        const { data, errorMessage, isSuccess } = await commonNetwork.get("/CardBrand/all", null, apiInfo);

        if (data) {
            setBrandList(data);
        }
    }

    /*
    {
    "id": 1,
    "type": "Bonus",
    "name": "Bonus",
    "image": "/images/brandlogos/bonus.webp"
}
    */
    return (
        <div className="flex justify-content-center align-items-center mt2 flex-wrap">
            {brandList.map((item, index) => (
                <img key={"brands" + index} className="h-50 mt-4 brand-img  " src={rootUrl + item.image} width={"auto"} />
            ))}
        </div>
    );
}

export default FooterAllBrands;